/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export {
  ORIGIN_URL as ɵORIGIN_URL,
  REQUEST as ɵREQUEST,
  RESPONSE as ɵRESPONSE
} from './src/tokens';
